import { useEffect, useState } from "react"

import { css, cx } from "@emotion/css"
import { queryCache, useMutation } from "react-query"

import { GhostMoneys } from "components/inputs/Moneys"
import Surface from "components/Surface"
import { updateMarket } from "api/regions"
import { useAuthenticated } from "providers/A12n"
import { useI18n } from "providers/I18n"

type Props = {
  rounding?: string
  id?: string
}

export const AddRoundingLimit = (props: Props) => {
  const { t } = useI18n()
  const { rounding, id } = props
  const { hasAuthority } = useAuthenticated()

  const [value, setValue] = useState<string | undefined>(() => rounding)

  // patch market inputs
  const [update] = useMutation(updateMarket, {
    onSuccess: () => {
      queryCache.invalidateQueries("current-market")
    },
  })

  const onChange = (v: string) => {
    setValue(v)
  }

  const onBlur = () => {
    const hasValueDiff = rounding !== value

    if (hasValueDiff) {
      update({ id: id, rounding: value })
    }
  }

  useEffect(() => {
    setValue(rounding)
  }, [rounding])

  const disabled = !hasAuthority(["AUTH_EDIT_MARKET"])

  return (
    <Surface>
      <h5 className={cx(styles.header, "BodyBody-1BlackBold")}>
        {t("market.invoiceRounding.header")}
      </h5>
      {!!id && (
        <GhostMoneys
          id={id}
          placeholder={t("market.invoiceRounding.upperLimit")}
          name="rounding"
          disabled={disabled}
          value={value}
          setValue={onChange}
          onBlur={onBlur}
          classes={{
            input: styles.input,
          }}
        />
      )}
    </Surface>
  )
}

const styles = {
  header: css`
    padding: 8px 0px 24px;
  `,
  input: css`
    width: 280px;
    height: var(--spacing-xxl-4);
    padding: 0 var(--spacing-s);
    border: 1px solid #c6c5c5;
    border-radius: 4px;
  `,
}
